module.exports = __webpack_public_path__ + "static/media/about_pc_1.2737b414.png";